'use strict';

var regex = /(auto|scroll)/;

var hasOverflow = function hasOverflow(element) {
  var style = window.getComputedStyle(element, null);
  return regex.test(style.getPropertyValue('overflow') + style.getPropertyValue('overflow-y') + style.getPropertyValue('overflow-x'));
};
module.exports = hasOverflow;


//////////////////
// WEBPACK FOOTER
// ./~/scrollfeatures/lib/has-overflow.js
// module id = 67
// module chunks = 24564523585802 77757019989577 88899200817339 114276838955818 159264293819137 170425996347293 257404837723318 262202390628140